/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { IconButton, IconButtonProps } from "@mui/material";

export default function InfoIconButton(props: IconButtonProps) {
  return (
    <IconButton sx={{ height: "40px", width: "40px" }} aria-label={"Erklärung anzeigen"} {...props}>
      <InfoOutlinedIcon
        sx={{
          height: "1.25rem",
          cursor: "help",
        }}
        aria-hidden={false}
      />
    </IconButton>
  );
}
